import { useMemo } from 'react'
import { Platform } from 'react-native'

import * as S from './select-dropdownlist.styles'

import { useTheme } from '~/hooks'

import { OptionMenu } from '~/components/option-menu'

import { HELPER_TEXT_HEIGHT } from '../input-select-helpertext'

import { DISPLAY_NAME, useSelectContext } from '../../input-select'

import type { InputSelectProps, ScopedProps } from '../../input-select.types'

type SelectDropdownProps = {
  children: (
    option: InputSelectProps['options'][0],
    index: number
  ) => undefined | React.ReactNode
  testID?: string
}

function SelectDropdownList(props: SelectDropdownProps) {
  const theme = useTheme()

  const { children, testID, __scopeSelect } =
    props as ScopedProps<SelectDropdownProps>

  const { options, isFocused, triggerLayoutInfo } = useSelectContext(
    DISPLAY_NAME,
    __scopeSelect
  )

  const spaceBetweenSelectAndDropdown =
    Platform.OS === 'ios' ? theme.spacingStackOnepulse + HELPER_TEXT_HEIGHT : 0

  const renderChildren = useMemo(
    () =>
      typeof children === 'function'
        ? options.map((option, index) => children(option, index))
        : children,
    [children, options]
  )

  const hasOptions = options.length > 0

  if (!isFocused) return null

  return (
    <S.DropdownList
      collapsable={false}
      testID={testID}
      style={{
        width: triggerLayoutInfo.width,
        left: triggerLayoutInfo.x,
        top: triggerLayoutInfo.y + spaceBetweenSelectAndDropdown,
      }}
    >
      <OptionMenu.Root type="single">
        {hasOptions ? (
          <OptionMenu.List testID="option-menu-list">
            {/* biome-ignore lint/complexity/noUselessFragments: */}
            <>{renderChildren}</>
          </OptionMenu.List>
        ) : null}
      </OptionMenu.Root>
    </S.DropdownList>
  )
}

export { SelectDropdownList }
